exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*styles for home content only*/\n.home-container {\n  background-color: transparent; }\n\n.header-row {\n  margin-top: 2%;\n  text-align: center; }\n\n.wav-logo-container {\n  text-align: center;\n  margin-top: 2%;\n  margin-bottom: 2%; }\n\n.wav-logo {\n  cursor: pointer; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/header/header.component.scss
// module id = JZ/M
// module chunks = 1